import { createSelector } from "reselect"
import { map, pick } from "lodash"

const getPositionSets = (_, props) => props.positionSets

export const getItems = createSelector(
  [getPositionSets],
  (positionSets) => map(positionSets, (ps, index) => ({
    id: String(index),
    disabled: ps.isUnmodeled,
    ...pick(ps, ["label", "color", "noData", "isUnmodeled"]),
  })),
)
